import { render, staticRenderFns } from "./ClarificationList.vue?vue&type=template&id=c95c3b4a&"
import script from "./ClarificationList.vue?vue&type=script&lang=js&"
export * from "./ClarificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports